var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_8855)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_654_8855",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_654_8855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0103 16.9993C11.1603 16.9993 10.3003 16.7793 9.63031 16.3493L3.61031 12.4193C2.49031 11.6893 1.82031 10.4593 1.82031 9.1193C1.82031 7.7793 2.49031 6.5493 3.61031 5.8193L9.64031 1.8993C10.9803 1.0293 13.0703 1.0293 14.4003 1.9093L20.3903 5.8393C21.5003 6.5693 22.1703 7.7993 22.1703 9.1293C22.1703 10.4593 21.5003 11.6893 20.3903 12.4193L14.4003 16.3493C13.7303 16.7893 12.8703 16.9993 12.0103 16.9993ZM12.0103 2.7493C11.4403 2.7493 10.8703 2.8793 10.4603 3.1593L4.44031 7.0793C3.74031 7.5393 3.33031 8.2793 3.33031 9.1193C3.33031 9.9593 3.73031 10.6993 4.44031 11.1593L10.4603 15.0893C11.2903 15.6293 12.7503 15.6293 13.5803 15.0893L19.5703 11.1593C20.2703 10.6993 20.6703 9.9593 20.6703 9.1193C20.6703 8.2793 20.2703 7.5393 19.5703 7.0793L13.5803 3.1493C13.1603 2.8893 12.5903 2.7493 12.0103 2.7493Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.7501C11.5601 22.7501 11.1101 22.6901 10.7501 22.5701L7.56018 21.5101C6.05018 21.0101 4.86018 19.3601 4.87018 17.7701L4.88018 13.0801C4.88018 12.6701 5.22018 12.3301 5.63018 12.3301C6.04018 12.3301 6.38018 12.6701 6.38018 13.0801L6.37018 17.7701C6.37018 18.7101 7.15018 19.7901 8.04018 20.0901L11.2301 21.1501C11.6301 21.2801 12.3701 21.2801 12.7701 21.1501L15.9601 20.0901C16.8501 19.7901 17.6301 18.7101 17.6301 17.7801V13.1401C17.6301 12.7301 17.9701 12.3901 18.3801 12.3901C18.7901 12.3901 19.1301 12.7301 19.1301 13.1401V17.7801C19.1301 19.3701 17.9501 21.0101 16.4401 21.5201L13.2501 22.5801C12.8901 22.6901 12.4401 22.7501 12.0001 22.7501Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4004 15.75C20.9904 15.75 20.6504 15.41 20.6504 15V9C20.6504 8.59 20.9904 8.25 21.4004 8.25C21.8104 8.25 22.1504 8.59 22.1504 9V15C22.1504 15.41 21.8104 15.75 21.4004 15.75Z",
    fill: "#FFB600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_8855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education-icon.5a34222e96d8d03bb5e50591d6975668.svg";
export { ForwardRef as ReactComponent };